import { Events } from "@tarojs/taro";
export const toastEvents = new Events();
export const toastSelectorSet = new Set();
